import Panel from '../../Panel'
import { useUIComponentsContext } from '../../Provider/UiComponentsProvider'
import { useAccessContext } from '../AccessProvider'
import ContributorContainer from '../Components/ContributorContainer'
import TeamContributorCard from '../Components/TeamContributorCard'
import UserContributor from '../Components/UserContributor'
import { AccessAccount } from '../types'
import { CONTRIBUTOR_RIGHTS } from '../utils'

export interface IDefaultTab {
  onOwnerChange?: (newOwner: AccessAccount) => void
  resourceOwner: AccessAccount
}

const DefaultTab = ({ resourceOwner }: IDefaultTab) => {
  const { t } = useUIComponentsContext()
  const { userContributors, teamContributors } = useAccessContext()

  const { OWNER } = CONTRIBUTOR_RIGHTS(t)

  const projectResponsible = userContributors?.find(
    (c) => c?.account.id === resourceOwner?.id
  )

  const resolvedProjectResponsible = resourceOwner
    ? userContributors?.find((c) => c?.account.id === resourceOwner?.id)
    : null

  const resolvedRestUserContributors = resourceOwner
    ? userContributors?.filter((c) => c?.account.id !== resourceOwner?.id)
    : userContributors

  return (
    <>
      {resourceOwner && (
        <ContributorContainer
          title={t?.('access.owner')}
          containerClassName="bg-oxford-gray-50"
          contributors={
            <UserContributor
              key={resourceOwner?.id}
              account={resourceOwner}
              access={OWNER.value}
              showMoreActions={false}
            />
          }
        />
      )}

      {resolvedProjectResponsible && (
        <UserContributor
          key={resolvedProjectResponsible?.account?.id}
          account={resolvedProjectResponsible.account}
          disabled
          access={resolvedProjectResponsible.access}
          showMoreActions={false}
          isProjectResponsible
        />
      )}

      {!!teamContributors?.length && (
        <ContributorContainer
          title={t?.('access.teams')}
          contributors={teamContributors.map((teamContributor) => (
            <TeamContributorCard
              disabled
              key={teamContributor.team.id}
              teamContributor={teamContributor}
              projectResponsibleId={projectResponsible?.account?.id}
              resourceOwnerId={resourceOwner?.id}
            />
          ))}
        />
      )}

      {resolvedRestUserContributors?.length > 0 && (
        <ContributorContainer
          title={t?.('access.individualUsers')}
          contributors={
            <Panel
              title={t?.('access.users')}
              buttonAs="div"
              shadowClassName=""
              labelClassName="text-sm"
              className="mb-3"
              btnClassName="bg-electric-violet-50"
            >
              <div className="pl-3">
                <div>
                  {resolvedRestUserContributors.map(
                    ({ account, access, ...rest }) => (
                      <UserContributor
                        key={account.id}
                        account={account}
                        access={access}
                        disabled
                        {...rest}
                      />
                    )
                  )}
                </div>
              </div>
            </Panel>
          }
        />
      )}
    </>
  )
}

export default DefaultTab
